import cn from 'clsx'
import * as React from 'react'
import { useDrop } from 'react-dnd'

import { dndConnectRef } from 'utils/dnd-connect-ref'

import { SECTION_BLOCK } from './constants'

type BlockDropResult = {
  sectionIndex: number
  columnIndex?: number
  contentIndex?: number
}

type Props = {
  type: 'section' | 'content'
  campaignId: string
  sectionIndex: number
  columnIndex?: number
  contentIndex?: number
  children: React.ReactNode
}

export default function BlockDropWrapper({
  sectionIndex,
  columnIndex,
  contentIndex,
  children,
}: Props) {
  const [{ isOver }, dropRef] = useDrop<
    unknown,
    BlockDropResult,
    { isOver: boolean }
  >(
    () => ({
      accept: SECTION_BLOCK,
      // drop returns the target coordinates; the drag source's endDrag
      // dispatches the actual insert/move.
      // https://github.com/react-dnd/react-dnd/issues/557
      drop: () => ({ sectionIndex, columnIndex, contentIndex }),
      collect: monitor => ({ isOver: monitor.isOver() }),
    }),
    [sectionIndex, columnIndex, contentIndex],
  )

  return (
    <div
      ref={dndConnectRef(dropRef)}
      className={cn({ 'block-drop-over': isOver })}
    >
      {children}
    </div>
  )
}
